// Shared DOM utility helpers for i18n debug tools
// Avoids duplication across altAnnotator and textScanner

export function excludeByAncestor(el, tags) {
  if (!tags?.length) return false
  let anc = el
  while (anc) {
    if (tags.includes(anc.tagName)) return true
    anc = anc.parentElement
  }
  return false
}
